import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { REGEX } from 'src/app/models/Constants';
import { columnsModel } from 'src/app/models/customer.model';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AlightTableComponent } from '../common/alight-table/alight-table.component';
import { AlightSmartSearchDropDownComponent } from '../common/alight-smart-search-drop-down/alight-smart-search-drop-down.component';
import * as Constants from '../../models/Constants';
import _ from 'lodash';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomMomentDateAdapter } from 'src/app/models/customMomentDateAdapter';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { SimulationService } from 'src/app/services/simulation.service';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';

declare var $: any;

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM-DD-YYYY',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-simulation-manager',
  templateUrl: './simulation-manager.component.html',
  styleUrls: ['./simulation-manager.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomMomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class SimulationManagerComponent implements OnInit, OnDestroy {
  customerSearchForm: FormGroup = new FormGroup({});
  errorMsg = Constants.AlertMsg;
  Constants = Constants;
  // Constant values for Authentication Method dropdown
  authenticationMethod = [{ id: 1, fieldValueDescription: 'CIM Model' }, { id: 2, fieldValueDescription: 'Indicative Data' }]
  public dataSource: any = new MatTableDataSource();
  selectedRow: any;
  totalRecords!: number;
  @ViewChild(AlightTableComponent) alightTable;
  @ViewChild(AlightSmartSearchDropDownComponent) alightSmartSearch;
  public Columns: columnsModel[] = [
    { field: 'lastName', header: 'Last Name', width: 24 },
    { field: 'firstName', header: 'First Name', width: 24 },
    { field: 'address', header: 'Address', width: 40 },
    { field: 'dateOfBirth', header: 'Date of Birth', width: 10 },
    { field: 'nationalId', header: 'National ID', width: 10 },
    { field: 'employeeId', header: 'Emp ID', width: 10 },
    { field: 'postalCode', header: 'Postal Code', width: 10 },
  ];
  public maxDate = new Date();
  clientId: any;clientName:any;
  loaderType = Constants.LOADER_TYPE.CARD;

  constructor(public fb: FormBuilder,
    public rootService: RootScopeService,
    public customerService: CustBusService, public simulationService: SimulationService, public CCT_API_service: NewAgentApiService) {
    this.createCustomerSearchForm();
  }

  /**
   * Angular lifecycle hook that is called after the component's data-bound properties have been initialized.
   * Hides any currently displayed error messages by invoking the `hideError` method of the `rootService`.
   */
  ngOnInit(): void {
    this.rootService.hideError();
    if(this.rootService.isLiveCall || this.rootService.simulationRecords.length>=this.rootService.CCTConfigs.MAXMIUM_ACCOUNTS){
       this.simulationService.disableSimulationForm(this);
    }
   
  }

  /**
   * @author VamsiKrishna
   * Initializes the `customerSearchForm` FormGroup with controls for customer search criteria.
   *
   * The form includes the following fields:
   * - `clientId`: Required. The client identifier.
   * - `SIM_clientName`: Required. The name of the SIM client.
   * - `simulationType`: Required. The type of simulation.
   * - `lastName`: Required. The customer's last name. Must match the `REGEX.character` pattern.
   * - `firstName`: Optional. The customer's first name.
   * - `dateOfBirth`: Optional. The customer's date of birth.
   * - `nationalId`: Optional. The customer's national ID. Must be exactly 4 characters and match the `REGEX.nospace` pattern.
   * - `employeeId`: Optional. The employee identifier.
   * - `postalCode`: Optional. The postal code.
   * CCR3-4177
   * Validators are applied to ensure required fields and pattern/length constraints are enforced.
   */
  createCustomerSearchForm() {

    this.customerSearchForm = this.fb.group({
      clientId: new FormControl("", Validators.required),
      SIM_clientName: new FormControl("", Validators.required),
      simulationType: new FormControl("", Validators.required),
      authModels:new FormControl("", Validators.required),
      lastName: new FormControl('', [
        //Validators.required, CCR1-13609 Removed lastName as required field for simulation manager
        Validators.pattern(REGEX.character),
      ]),
      firstName: new FormControl(''),
      dateOfBirth: new FormControl<Date | null>(null),
      nationalId: new FormControl('', [
        Validators.minLength(4), Validators.maxLength(4),
        Validators.pattern(REGEX.nospace),
      ]),
      employeeId: new FormControl('',
        // CCR1-13609 Customer Search Enhancement
         [Validators.minLength(4), Validators.pattern(REGEX.nospace),Validators.pattern(/^[A-Za-z0-9]*$/), this.noSpecialCharactersValidator]),
      postalCode: new FormControl(''),
      // CCR1-13609 Customer Search Enhancement
      phoneNumber: new FormControl('',[
        Validators.minLength(3),
        Validators.pattern(/^[0-9]*$/),
        this.noSpecialCharactersValidator,
      ]),
    });
  }


  /**
   * @author VamsiKrishna
   * Handles the focus event for the customer search form.
   * 
   * If any of the required form fields (`clientId`, `SIM_clientName`, `similationTypes`, or `lastName`)
   * are missing values, this method marks those fields as touched to trigger validation messages.
   *CCR3-4177
   * @param event - The focus event object.
   */
  onFocus(event) {
    if (
      !this.customerSearchForm.value.clientId || !this.customerSearchForm.value.SIM_clientName || !this.customerSearchForm.value.simulationType 
    ) {
      this.customerSearchForm.get('clientId')?.markAsTouched();
      this.customerSearchForm.get('SIM_clientName')?.markAsTouched();
      this.customerSearchForm.get('simulationType')?.markAsTouched();
      /* CCR1-13609 Customer Search Enhancement - Removing dead code as lastName is no longer mandatory */
      //this.customerSearchForm.get('lastName')?.markAsUntouched();
     
    }
    // else if(!this.customerSearchForm.value.lastName&&event?.target?.id != 'lastName'){
    //   this.customerSearchForm.get('lastName')?.markAsTouched();
    // }
  }

  
  /**
   * Handles the selection of a row in the simulation manager component.
   *@author VamsiKrishna
   * Depending on the `activateBtn` property of the input data, this method either:
   * - Sets the selected row without further action if `activateBtn` is true.
   * - Sets the selected row, updates its `customerType` and `clientId` properties,
   *   and routes to customer accounts if `activateBtn` is false or undefined.
   * CCR3-4177
   * @param data - The data object containing information about the selected row and button state.
   *   @property {boolean} [activateBtn] - Indicates if the activate button was pressed.
   *   @property {any} row - The row object being selected.
   *   @property {string} [buttonName] - The name of the button triggering the selection.
   */
  rowSelection(data) {
    if (data?.activateBtn) {
      this.selectedRow = data?.row;
    }
    
    else {
      // CCR3-5293 Handling unknown simulation type error
      if(data?.row)
      this.selectedRow = data?.row;
     else
      data.row=new Object();
      data.row.customerType = 'ACH';
      data.row.clientId = this.customerSearchForm?.value?.clientId;
      // CCR3-5293 Spoofing ALIS- Unsecured & Secured Calls
      data.row.simulationType = this.customerSearchForm?.value?.simulationType;
      data.row.SIM_clientName = this.customerSearchForm?.value?.SIM_clientName;
      data.row.authModels = this.customerSearchForm?.value?.authModels;
      this.simulationService.routeToCustomerAccounts(data);
    }
  }
  /*Clear all Based on live call and off call
  CCR3-4177 */
 
  public clearAll() {
    if(!(this.rootService.isLiveCall || this.rootService.simulationRecords.length>=this.rootService.CCTConfigs.MAXMIUM_ACCOUNTS)){
    
    
    this.enableDisableForm(true);
    this.customerSearchForm.reset();
    $('#txtSimulationForm')[0]?.reset();
    this.clientId = 'NA';
    this.customerSearchForm?.get('clientId')?.setValue('NA');
    this.customerSearchForm?.get('SIM_clientName')?.setValue('');
    this.customerSearchForm?.get('SIM_clientName')?.markAsUntouched();
   
    this.customerSearchForm?.get('clientId')?.markAsUntouched();
    // To open the panel of client dropdown after clearing all fields
    //
    this.alightSmartSearch?.matAutocompleteTrigger?.openPanel();
    this.selectedRow = null;
    this.totalRecords = 0;
    this.alightTable?.clearAll();
    this.dataSource = new MatTableDataSource([]);
    this.rootService.scrollToTop();
    }
  }
  
  /**
   * Handles the form submission event for the customer search.
   * CCR3-4177
   * This method performs the following actions:
   * - Resets the selected row.
   * - Sets the customer search loading indicator to true.
   * - Initiates a customer search request using the form values.
   */
  onSubmit() {
    this.selectedRow = null;

    this.rootService.custSearchLoader = true;
    //CCR1-13609 Customer Search Enhancement
      if (!this.hasAnySearchCriteria()) {
        // just prevent submit silently
        this.rootService.custSearchLoader = false;

        return;

      }

    this.customerService.getSearchData(this.customerSearchForm.value, this);
  }

  /*CCR1-13609 Customer Search Enhancement*/
  public checkSearchDisable() {
    const clientId = this.customerSearchForm.get('clientId')?.value;
    const clientName = this.customerSearchForm.get('SIM_clientName')?.value;
    const simulationType = this.customerSearchForm.get('simulationType')?.value;
    const authModels = this.customerSearchForm.get('authModels')?.value;

    const isSecuredWebMessage =
      simulationType === Constants.SIMULATION_TYPES.SECURED_WEBMESSAGE;

    const isUnknownSimulation = this.unknown_CALL_TYPE_LIST();

    const hasRequiredClient =
      !!clientId && !!clientName;

    const hasRequiredAuthentication =
      isSecuredWebMessage || !!authModels;

    return !(
      hasRequiredClient &&
      !!simulationType &&
      hasRequiredAuthentication &&
      !isUnknownSimulation &&
      this.customerSearchForm.valid
    );
  }

  /**
   * Initiates the simulation process by selecting the currently highlighted row
   * in the `alightTable` and passing it to the `rowSelection` handler.
   *CCR3-4177
   * This method is typically triggered by a user action, such as clicking a "Start Simulation" button.
   */
  startSimulation() {
    this.rowSelection({ row: this.alightTable.selectedRow }); 

  }

  /**
   * Handles changes to the client selection.
   *
   * Updates the `clientId` property and the `clientId` form control in `customerSearchForm`
   * based on the selected value from the event. If a valid client is selected, sets the
   * `clientId` to the selected value. If no client is selected, sets the `clientId` to 'NA',
   * updates the form control accordingly, and initializes an empty array for the client in
   * the `clientInfoVSClientIdMap` of `clientInfoCard` in `rootService`.
   *CCR3-4177
   * @param event - The event object containing the selected client value.
   */
  onClientChange(event) {
    if (event?.value) {
      this.clientId = event?.value;
      this.customerSearchForm?.get('clientId')?.setValue(event?.value);
      this.clientName = this.customerSearchForm?.get('SIM_clientName')?.value;
      this.CCT_API_service.getLOBMethodsForSimulation(event?.value);
      this.clearForm();
    }
    else if (this.clientName && this.clientName != event?.target?.value && this.totalRecords) {
      this.clearForm();
    }
    else if (event.isTrusted) {
      console.log('Simulation Manager: onClientChange');
    }
    else {
      this.clientId = 'NA';
      this.customerSearchForm?.get('clientId')?.setValue('NA');

    }
  }

  clearForm(){
    Object.keys(this.customerSearchForm.controls).forEach(key => {
      if (key !== 'clientId' && key !== 'SIM_clientName') {
        this.customerSearchForm.get(key)?.setValue('');
        this.customerSearchForm.get(key)?.markAsUntouched();
        this.customerSearchForm.get(key)?.setErrors(null);
      }
    });
    
    this.selectedRow = null;
    this.totalRecords = 0;
    this.alightTable?.clearAll();
    this.dataSource = new MatTableDataSource([]);
  }

  onClearSelection(clearFlag: boolean): void {

    if (clearFlag) {
      this.clearAll();
       
    }
  }

  unknown_CALL_TYPE_LIST() {
    const unknownCallList = [Constants.SIMULATION.UNKNOWN_INBOUND, Constants.SIMULATION.UNKNOWN_OUTBOUND, Constants.SIMULATION.UNKNOWN_CALLBACKCALL];
    return (this.customerSearchForm.get('clientId')?.value && this.customerSearchForm.get('simulationType')?.value && unknownCallList.includes(this.customerSearchForm.get('simulationType')?.value));
  }

  /**
   * Determines whether the "Start Simulation" button should be disabled.
   *
   * The button is disabled unless either:
   * - A simulation type is selected and a row is selected, or
   * - The simulation status (as determined by `unknown_CALL_TYPE_LIST()`) is truthy.
   * CCR3-4177
   * @returns `true` if the button should be disabled, `false` otherwise.
   */
  disableStartSimBtn() {
    let simulationStatus = (this.unknown_CALL_TYPE_LIST()  && this.customerSearchForm.get('authModels')?.value);

    return !((this.customerSearchForm.get('simulationType')?.value && this.selectedRow) || simulationStatus);
  }

  public errorHandling = (control: string, error: string) => {
    return this.customerSearchForm.value.clientId
      ? this.customerSearchForm.controls[control].hasError(error)
      : false;
  };

  /**
   * Handles changes to the simulation type selection.
   * 
   * Updates the validation state of the `lastName` form control based on the selected simulation type.
   * If the simulation type is `unknown_inbound` or `unknown_outbound`, the required validator is removed from `lastName`.
   * Otherwise, the required validator is added.
   * Also enables or disables the form accordingly.
   * CCR3-4177
   * @param event - The event object containing the selected simulation type value.
   */
  onSimulationChange(event) {
    const lastNameControl = this.customerSearchForm.get('lastName');

    // Add required validator to lastName if simulationType is not unknown_inbound or unknown_outbound
    if (this.unknown_CALL_TYPE_LIST()) {
      lastNameControl?.removeValidators(Validators.required);
      this.enableDisableForm(false);
    }
    else {
      //lastNameControl?.addValidators(Validators.required); CCR1-13609 Customer Search Enhancement - Removed lastName as required field for simulation manager
      this.enableDisableForm(true);
    }
    lastNameControl?.updateValueAndValidity();
  }

  /**
   * Enables or disables form controls in the `customerSearchForm` except for the required fields.
   *
   * @param status - If `true`, enables all non-required form controls. If `false`, disables them and resets their values.
   * 
   * The required fields (`clientId`, `SIM_clientName`, `simulationType`) are always left enabled and untouched.
   */
  enableDisableForm(status) {
    const requireFields = ['clientId', 'SIM_clientName', 'simulationType','authModels'];
    Object.keys(this.customerSearchForm.controls).forEach(Key => {
      if (!requireFields.includes(Key)) {
        if (status) {
          this.customerSearchForm.get(Key)?.enable();
        }
        else {
          this.customerSearchForm.get(Key)?.setValue('');
          this.customerSearchForm.get(Key)?.disable();
        }
      } else if (Key === 'simulationType') {
        if (this.customerSearchForm.get(Key)?.value === Constants.SIMULATION_TYPES.SECURED_WEBMESSAGE) {
          this.customerSearchForm.get('authModels')?.setValue('');
          this.customerSearchForm.get('authModels')?.clearValidators();

        }
        else {
          this.customerSearchForm.get('authModels')?.setValidators(Validators.required);
        }
        this.customerSearchForm.get('authModels')?.updateValueAndValidity();
      }
    });
    if (!status) {
      this.totalRecords = 0;
      this.alightTable?.clearAll();
      this.dataSource = new MatTableDataSource([]);
    }
  }

  /**
   * Returns the CSS class for security level based on simulation record
   * @param simRecord - The simulation record containing conversation attributes
   * @returns string - CSS class for security level (green, yellow, red)
   */
  getSecurityLevelClass(simRecord: any): string {
    const securityLevel = simRecord?.conversationAttributes?.CS_SECURITY_LEVEL;

    switch (securityLevel) {
      case '4':
        return 'green'; // Fully secured
      case '3':
        return 'yellow'; // Partially secured
      case '2':
      case '1':
        return 'red'; // Unsecured
      default:
        return 'red'; // Default to unsecured
    }
  }

  simulationTypeValueFilter() {
    if (this.rootService.isLiveChat) {
      // Return only the Secured Web Message type
      return this.rootService.simulationTypes.filter(
        (simType) => simType.fieldValueDescription === Constants.SIMULATION_TYPES.SECURED_WEBMESSAGE
      );
    } else {
      return this.rootService.simulationTypes;
    }
  }

  /**
        * CCR1-13609 Below method is Custom validator for no special characters which is used in form-field 
        **/
  noSpecialCharactersValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value || '';
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>\/+\-]/g;

    if (specialCharPattern.test(value)) {
      return { invalidSpecialChar: true };
    }
    return null;
  }

    /*CCR1-13609 - Customer Search Enhancement */
  /* Returns true if at least one customer search field is populated */
  hasAnySearchCriteria(): boolean {

    const searchFields = [
      'lastName',
      'firstName',
      'nationalId',
      'employeeId',
      'postalCode',
      'dateOfBirth',
      'phoneNumber',
    ];

    return searchFields.some((field) => {
      const value = this.customerSearchForm?.get(field)?.value;
      return value != null && value !== '';
    });
  }

  /** CCR1-13609 - Customer Search Enhancement.
   * Handles key up events for input fields - Utilized for Phone Number and Employee ID fields.
   * @param event - The key up event
   * @param option - The form field option
   */
  public onKeyUp(event, option) {
    switch (option) {
      case 'dateOfBirth':
        let DobVal = event.target.value;
        this.customerSearchForm.controls[option].markAsTouched();
        if (
          event.keyCode >= 48 &&
          event.keyCode <= 57 &&
          (DobVal?.length === 2 || DobVal?.length === 5)
        ) {
          this.customerSearchForm.controls['dateOfBirth'].setValue(
            DobVal + '/'
          );
        }
        break;

      default:
        if (event.target.value)
          this.customerSearchForm.controls[option].markAsTouched();

        break;
    }
  }

  ngOnDestroy() {
    this.rootService.showCustSearchLoaderMsg = false;
    this.rootService.hideError();
  }


}
